import { render } from "./LeaveBalancesManagement.vue?vue&type=template&id=8d989750&scoped=true"
import script from "./LeaveBalancesManagement.vue?vue&type=script&lang=js"
export * from "./LeaveBalancesManagement.vue?vue&type=script&lang=js"

import "./LeaveBalancesManagement.vue?vue&type=style&index=0&id=8d989750&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d989750"]])

export default __exports__